export default __webpack_public_path__ + "static/media/icon-info.66223e70.svg";